export const TEXT = {
    GROUPSHACK: 'GroupShack',
    LOGIN: 'login',
    SIGNUP: 'sign up'
};